/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { Typography, Grid, Alert, styled } from '@mui/material';
import { CallBox, CallButton, CallDetails, CallHeader, CallStateActive } from './call-styles';
import { Check, Close, Phone } from '@mui/icons-material';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { usePhoneActions } from '../../hooks/use-phone';
import CallWarningActions from './call-warning-actions';
import { formatUSPhoneNumber } from '../../utils/formatter';

const AlertSuccess = styled(Alert)(() => ({
    color: '#005E05',
    backgroundColor: '#D8F8D9',
    borderRadius: 16,
    marginTop: 16
}));

export default function CallWarningTryAgain() {
    const { phoneNumber, hideWarning } = usePhoneWarnings();
    const { contactNames } = useCallIdentity({ phoneNumber: phoneNumber as string });
    const { call } = usePhoneActions();

    return (
        <CallBox data-testid='call-warning-try-again'>
            <CallHeader>
                <Grid container>
                    <Grid item xs={6} zeroMinWidth>
                        <CallStateActive>PLACE CALL</CallStateActive>
                        <Typography variant='h6' noWrap>
                            {contactNames ? contactNames : ''}
                        </Typography>
                        <Typography variant='body2'>{formatUSPhoneNumber(phoneNumber!)}</Typography>
                        <Typography variant='body2'>--:--</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <CallButton
                            onClick={() => {
                                hideWarning();
                                call(phoneNumber!);
                            }}
                            sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}
                        >
                            <Phone />
                        </CallButton>
                        <CallButton onClick={hideWarning} palleteKey='secondary'>
                            <Close sx={{ fontSize: 32 }} />
                        </CallButton>
                    </Grid>
                </Grid>
                <AlertSuccess icon={<Check style={{ fontSize: 22, color: '#008A06' }} />}>
                    You can now place your call
                </AlertSuccess>
            </CallHeader>
            <CallDetails>
                <CallWarningActions phoneNumber={phoneNumber!} />
            </CallDetails>
        </CallBox>
    );
}
